import MenuIcon from '@mui/icons-material/Menu';
import {
    AppBar,
    Box,
    Button,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { publicColors } from './publicTheme';

const NAV_ITEMS = [
    { id: 'top', label: 'Início', href: '/', isRoute: true },
    { id: 'plataforma', label: 'Plataforma', href: '#plataforma' },
    { id: 'metricas', label: 'Métricas', href: '#metricas' },
    { id: 'calculator', label: 'Calculadora Grátis', href: '/calculator', isRoute: true },
    // { id: 'depoimentos', label: 'Feedback', href: '#depoimentos' },
    { id: 'precos', label: 'Planos', href: '#precos' },
];

const Header = () => {
    const [activeSection, setActiveSection] = useState('top');
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/calculator') {
            setActiveSection('calculator');
            return undefined;
        }
        if (location.pathname !== '/') {
            setActiveSection('');
            return undefined;
        }

        const handleScroll = () => {
            const headerHeight = document.querySelector('header')?.offsetHeight || 72;
            const sections = document.querySelectorAll('section[id]');
            let current = 'top';
            sections.forEach((section) => {
                const top = section.offsetTop - headerHeight - 8;
                if (window.scrollY >= top) {
                    current = section.id;
                }
            });
            setActiveSection(current);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location.pathname]);

    const goTo = (item) => {
        setMobileOpen(false);
        if (item.isRoute) {
            navigate(item.href);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => scrollToSection(item.href), 300);
        } else {
            scrollToSection(item.href);
        }
    };

    const scrollToSection = (hash) => {
        const id = hash.replace('#', '');
        const el = document.getElementById(id);
        const headerHeight = document.querySelector('header')?.offsetHeight || 72;
        if (el) {
            window.scrollTo({ top: el.offsetTop - headerHeight, behavior: 'smooth' });
        }
    };

    const navLinkSx = (id) => {
        const isActive = activeSection === id;
        return {
            color: '#fff',
            opacity: isActive ? 1 : 0.88,
            fontWeight: isActive ? 700 : 500,
            fontSize: '0.95rem',
            textTransform: 'none',
            minWidth: 'auto',
            px: 1.25,
            py: 0.75,
            borderRadius: 1,
            bgcolor: isActive ? 'rgba(255,255,255,0.18)' : 'transparent',
            '&:hover': { bgcolor: isActive ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.08)' },
        };
    };

    const drawer = (
        <Box sx={{ width: 280, pt: 2 }} role="presentation">
            <List>
                {NAV_ITEMS.map((item) => (
                    <ListItemButton
                        key={item.id}
                        selected={activeSection === item.id}
                        onClick={() => goTo(item)}
                    >
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                ))}
                <ListItemButton component={RouterLink} to="/admin/login" onClick={() => setMobileOpen(false)}>
                    <ListItemText primary="Entrar" />
                </ListItemButton>
            </List>
        </Box>
    );

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                bgcolor: publicColors.primary,
                borderBottom: `1px solid ${publicColors.primaryDark}`,
            }}
        >
            <Toolbar sx={{ maxWidth: 1120, width: '100%', mx: 'auto', px: { xs: 2, md: 3 } }}>
                <Typography
                    component={RouterLink}
                    to="/"
                    sx={{
                        flexGrow: 1,
                        fontFamily: '"Curitiba", sans-serif',
                        fontWeight: 'lighter',
                        letterSpacing: '1px',
                        color: '#fff',
                        textDecoration: 'none',
                        fontSize: { xs: '1rem', sm: '1.15rem' },
                    }}
                >
                    ACOMPANHA 3D
                </Typography>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5 }}>
                    {NAV_ITEMS.map((item) => (
                        <Button key={item.id} onClick={() => goTo(item)} sx={navLinkSx(item.id)}>
                            {item.label}
                        </Button>
                    ))}
                    <Button
                        component={RouterLink}
                        to="/admin/login"
                        variant="contained"
                        sx={{
                            ml: 1,
                            bgcolor: publicColors.surface,
                            color: publicColors.primary,
                            fontWeight: 700,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: publicColors.surfaceAlt, boxShadow: 'none' },
                        }}
                    >
                        Entrar
                    </Button>
                </Box>
                <IconButton
                    color="inherit"
                    edge="end"
                    sx={{ display: { md: 'none' } }}
                    onClick={() => setMobileOpen(true)}
                    aria-label="menu"
                >
                    <MenuIcon />
                </IconButton>
            </Toolbar>
            <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
                {drawer}
            </Drawer>
        </AppBar>
    );
};

export default Header;
